module.exports = "\n<div style=\"width: 100%;height: 100%;\">\n  <img [src]=\"src\" style=\"width: 100%;height: 100%;cursor: pointer; object-fit: contain;\"  (click)=\"BaseImage.click()\" />\n  <input type=\"file\" #BaseImage accept=\"image/*\" (change)=\"handleBaseFileInput($event.target.files)\"\n    style=\"width:117px; display: none;\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/image-uploader/image-uploader.component.html
// module id = ../../../../../src/app/shared/component/image-uploader/image-uploader.component.html
// module chunks = main